import React from "react";
import { TargetIcon, CheckCircleIcon, BoltIcon } from "./AnalyticsIcons";

const METRICS = [
  {
    label: "Goals Achieved",
    value: "12/15",
    percent: 80,
    icon: <TargetIcon size={18} color="#eb1414" />,
  },
  {
    label: "Tasks Completed",
    value: "89",
    percent: 89,
    icon: <CheckCircleIcon size={18} color="#eb1414" />,
  },
  {
    label: "Response Time",
    value: "1.2s",
    percent: 92,
    icon: <BoltIcon size={18} color="#eb1414" />,
  },
];

const AnalyticsPerformanceMetrics = () => {
  return (
    <div className="v2-analytics-pg-perf">
      <div className="v2-analytics-pg-perf__header">
        <h3 className="v2-analytics-pg-perf__title">Performance Metrics</h3>
        <p className="v2-analytics-pg-perf__subtitle">
          Your efficiency and productivity stats
        </p>
      </div>
      <div className="v2-analytics-pg-perf__list">
        {METRICS.map((metric) => (
          <div className="v2-analytics-pg-perf__item" key={metric.label}>
            <div className="v2-analytics-pg-perf__item-top">
              <div className="v2-analytics-pg-perf__item-label">
                {metric.icon}
                <span>{metric.label}</span>
              </div>
              <span className="v2-analytics-pg-perf__item-value">
                {metric.value}
              </span>
            </div>
            <div className="v2-analytics-pg-perf__bar-track">
              <div
                className="v2-analytics-pg-perf__bar-fill"
                style={{ width: `${metric.percent}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnalyticsPerformanceMetrics;
